import { render, staticRenderFns } from "./phone-icon.vue?vue&type=template&id=23fc9fa2&"
import script from "./phone-icon.vue?vue&type=script&lang=js&"
export * from "./phone-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports